import React from 'react';
import { CircularProgress, styled, Typography } from '@mui/material';

const Container = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1400,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'rgba(250, 250, 250, 0.5)',
});

const InsideSaving: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <Container>
      <CircularProgress color="primary" />
      <Typography fontSize={12} color="primary">
        {message || 'Salvando...'}
      </Typography>
    </Container>
  );
};

export default InsideSaving;
